import React, { Component } from 'react'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import invoicelogo from '../../assets/images/logo.png'
import { SubscribeInvoice } from '../../action/SubscriptionManagement';
import moment from 'moment';
export default class TransactionInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: ''
    };

  }

  printPDF2 = () => {

    window.html2canvas = html2canvas;
    var doc = new jsPDF({
      orientation: "p",
      unit: "px",
      format: "a4",
    });

    var content = document.getElementById("invoice");
    const width = doc.internal.pageSize.getWidth();
    const { detail } = this.state;
    doc.html(content, {
      x: 0,
      y: 0,
      width: width,
      autoPaging: 'text',
      windowWidth: 794,
      margin: [0, 0, 10, 0],
      html2canvas: { scale: 0.57 },
    })
      .then(() => {
        doc.save("JZSHRE" + detail.PKG_SUBSC_ID + "_invoice");
      });


  }
  componentDidMount() {
    this.TransactionInvoice();

  }

  TransactionInvoice = () => {

    SubscribeInvoice(this.props?.invoiceid).then((res) => {
      console.log(res.result.list, "subinvoiceid"
      )
      if (res.status) {
        this.setState({ detail: res.result.list });
      }
    }).catch((err) => {
      alert(err)
    })
  }

  render() {
    const { detail } = this.state

    return (

      <div>
        <div className='invoice-close'><button type="cancel" onClick={this.props.toggleModal}><i className='fa fa-close' style={{ fontSize: "20px", color: "#464646" }}></i></button></div>
        <div className='btn-group-sm d-print-none'>



          <div className='invoice-main-bx' >

            <div className='container-fluid invoice-container' id={'invoice'} style={{ padding: "15px 30px" }}>

              <header>
                <div className='row align-items-center'>
                  <div className='col-sm-7 text-center text-sm-start mb-3 mb-sm-0'>

                    <img src={invoicelogo} style={{width: "200px"}}/>
                  </div>
                  <div className='col-sm-5 text-center text-sm-end'>
                    <h4 className='text-7 mb-0'>Invoice</h4>

                  </div>
                </div>

              </header>

              <div className='border-hr'></div>

              <main>
                <div className='row'>
                  <div className='col-sm-6'><strong>Date:</strong> {moment(detail.START_DATE).format('DD-MM-YYYY')}</div>
                  <div className='col-sm-6 text-sm-end'> <strong>Invoice ID:</strong> JZSHRE{detail.PKG_SUBSC_ID}</div>

                </div>
                <div className='border-hr'></div>
                <div className='row'>
                  <div className='col-sm-6 text-sm-end order-sm-1'> <strong>Pay To:</strong>
                    <address className='addr-height'>
                      <span>JobzShala.com</span>

                      <span>4, 2nd Floor, K.R. Garden, 5th Main Rd</span>
                      <span>Koramangala 8th Block, Koramangala, </span>
                      <span>Bengaluru, Karnataka, India, 560029</span>
                      <span></span>
                      <span>info@jobzshala.com</span>
                    </address>
                  </div>
                  <div className='col-sm-6 order-sm-0'> <strong>Invoiced To:</strong>
                    <address className='addr-height'>
                      <span>{detail.COMPANY_NAME}</span>
                      <span> {detail.ADDRESS}</span>
                      {/* <span>{detail.CITY},{detail.STATE} ,{detail.COUNTRY}</span> */}
                      <span>{detail.EMAIL}</span>
                    </address>
                  </div>
                </div>
                <div className='border-hr'></div>
                <div className='card'>
                  <div className='card-body p-0'>
                    <div className='table-responsive'>
                      <table className='table mb-0'>
                        <thead className='card-header'>
                          <tr>
                            <td className='col-3'><strong>Subscription Type</strong></td>
                            <td className='col-4'><strong>Payment Status</strong></td>
                            <td className='col-2 text-center'><strong>Price</strong></td>
                            <td className='col-1 text-center'><strong>QTY</strong></td>
                            <td className='col-2 text-end'><strong>Amount</strong></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='col-3'>{detail.PACKAGE_TITE}</td>
                            <td className='col-4 text-1'> {detail.PAYMENT_STATUS == "S" ? (
                              <span>Successful</span>
                            ) : detail.PAYMENT_STATUS == "F" ? (
                              <span>Failure</span>
                            ) : detail.PAYMENT_STATUS == "P" ? (
                              <span> Processing </span>
                            ) : (
                              ""
                            )}</td>
                            <td className='col-2 text-center'>{detail.AMOUNT / detail.QTY}</td>
                            <td className='col-1 text-center'>{detail.QTY}</td>
                            <td className='col-2 text-end'>{detail.AMOUNT}</td>
                          </tr>
                          {/* <tr>
                          <td>Development</td>
                          <td className='text-1'>Website Development</td>
                          <td className='text-center'>$120.00</td>
                    <td className='text-center'>10</td>
                    <td className='text-end'>$1200.00</td>
                        </tr>
                  <tr>
                          <td>SEO</td>
                          <td className='text-1'>Optimize the site for search engines (SEO)</td>
                          <td className='text-center'>$450.00</td>
                    <td className='text-center'>1</td>
                    <td className='text-end'>$450.00</td>
                        </tr> */}
                        </tbody>
                        <tfoot className='card-footer'>


                          <tr>
                            <td colspan='4' className='text-end border-bottom-0'><strong>Total:</strong></td>
                            <td className='text-end border-bottom-0'>{detail.AMOUNT}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>

              </main>


            </div>
            <div className='invoice-btn-bx'><a onClick={() => { this.printPDF2() }} className='btn btn-light border text-black-50 shadow-none mb-4 mr-4'>
              <i className='fa fa-download'></i>Download</a>
            </div>

          </div>

        </div>
      </div>
    )
  }
}
